import React, { useState, useEffect } from "react";

//Importar íconos de Material UI.
import { AccountCircle, Facebook, WhatsApp, Construction, Settings } from '@mui/icons-material/';
import Multimedia from "./local_components/Multimedia";

// *******Componenete que renderiza el contenido del perfil del cliente********.

const ClientProfile = ({ sessionsChatSelected, chatData, socketConnected }) => {

    const [sessions, setSessions] = useState([]);  //Estados para actualizar las sesiones del chat seleccionado.
    const [chatName, setChatName] = useState(''); //Estados para actualizar el nombre del cliente.

    useEffect(() => { //Se ejecuta cada vez que cambia el chat seleccionado.
        //console.log('ESTOY SELECCIONADO DESDE CLIENTEPROFILE', chatData)
        const onChangeChat = () => { //Función para actualizar el estado que contiene las sesiones del chat.
            setSessions(sessionsChatSelected);
            setChatName(chatData.Nombre);
        };

        onChangeChat(); //Invocar a la función.
    }, [sessionsChatSelected, chatData]);


    return (
        <div className="container-chats__profile">
            {sessions.length > 0 && socketConnected &&
                <div className="container-clientprofile__profile"
                    style={{ border: `${sessions.length > 0 ? "solid 1px var(--bg-border-by-mode)" : ""}` }}>

                    {/*---------Encabezado del contenedor del perfil del cliente------------*/}
                    {/* <div className="container-chat__chat-header">
                        <div className="name-client-wiht-icon">
                            <span>Perfil</span>
                        </div>
                    </div> */}

                    <div className="container-profile__content">
                        {/*--------Contenedor con el icono de Chat animado---------- */}
                        <div className="content-mask-unselectedChat__icon" >
                            {/*--------Icono de Chat en el color de la paleta-------------- */}
                            <Settings className="rotate-icon" sx={{ fontSize: "150px", color: " var(--bg-ligth)" }} />
                        </div>
                        {/*------------Contenedor con el texto de seleccionar un chat */}
                        <div className="content-unselectedChat--text">
                            <span style={{display: "flex", alignItems: "center"}}>
                                 <Construction sx={{ fontSize: "30px", marginRight: "10px" }} /> 
                                 Área en desarrollo </span>
                        </div>

                        {/*----------Encabezado del contenedor----------- */}
                        {/*                     <AccountCircle sx={{ color: 'var(--bg-ligth)', fontSize: '170px' }} />
                    <span className="content-profile__content--name">{chatName}</span>
 */}
                        {/*----------Plataformas----------- */}
                        {/*                     <div className="container-profile__plataforms">
                        <span className="content-profile__plataforms--whatsapp" >WhatsApp</span>
                        <span className="content-profile__plataforms--messenger" >Messenger</span>
                    </div>
 */}
                        {/*----------Contenedor multimedia----------- */}
                        {/*                     <div className="container-profile__section">
                        <span className="content-profile__text--section">Media</span>
                        <Multimedia />
                    </div> */}

                        {/*----------Contenedor Contactos----------- */}
                        <div className="container-profile__section">
                            {/*                         <span className="content-profile__text--section">Contactos</span>
                        <div className="container-profile__plataform">
                            <div className="container-profile__plataform--icon--bg__container" >
                                <div className="container-profile__plataform--icon">
                                    <Facebook sx={{ color: "var(--bg-degradado)", fontSize: "30px" }} />
                                </div>
                            </div>
                            <span>{chatName}</span>
                        </div> */}

                            {/*                         <div className="container-profile__plataform">
                            <div className="container-profile__plataform--icon--bg__container" >
                                <div className="container-profile__plataform--icon">
                                    <WhatsApp sx={{ color: "var(--bg-degradado)", fontSize: "30px" }} />
                                </div>
                            </div>
                            <span>{chatName}</span>
                        </div> */}

                        </div>


                    </div>

                </div>}
        </div>
    )
};

export default ClientProfile;